/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import SwiperCore, { Autoplay } from 'swiper/core';

const Swiper = SwiperCore.use([Autoplay]);

import gsap from 'gsap';

const nonce = window.nonce;
const ajax_url = window.ajax;

export function init() {
  const cartOpen = document.querySelector('[data-cart-open]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartBackdrop = document.querySelector('[data-cart-backdrop]');

  if (cartOpen) {
    cartOpen.addEventListener('click', openCart);
  }

  if (cartClose) {
    cartClose.addEventListener('click', closeCart);
  }

  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', closeCart);
  }

  $(document).on('click', '[data-remove-item]', removeItemFromCart);
  $(document).on('change', '[data-quantity-input]', updateQuantity);
  $(document).on('change', '[data-meters-input]', updateMeters);

  // Add class to labels with pickup-address
  addPickupAddressClass();

  loadCartAmount();
}

function addPickupAddressClass() {
  // Find all labels that contain a pickup-address
  const labels = document.querySelectorAll('.woocommerce-shipping-methods label');
  labels.forEach((label) => {
    const pickupAddress = label.querySelector('.pickup-address');
    if (pickupAddress) {
      label.classList.add('has-pickup-address');
    }
  });
}

function updateQuantity() {
  let quantity = parseFloat($(this).val());
  const minQuantity = parseFloat($(this).attr('min')) || 1;
  const maxQuantity = parseFloat($(this).attr('max')) || Infinity;
  const step = parseFloat($(this).attr('step')) || 1;
  const itemKey = $(this).attr('data-item');

  // Always round UP to nearest multiple of step
  quantity = Math.ceil(quantity / step) * step;

  if (step === 0.5) {
    // Allow decimals like 5.5, but not more than 1 decimal
    quantity = Math.max(minQuantity, quantity);
    quantity = Math.round(quantity * 2) / 2;
  } else if (minQuantity === 1) {
    // If min is 1, do not allow decimals
    quantity = Math.max(minQuantity, Math.round(quantity));
  } else {
    quantity = Math.max(minQuantity, quantity);
  }

  if (maxQuantity && quantity > maxQuantity) {
    quantity = maxQuantity;
  }

  $(this).val(quantity);

  setCartLoader();

  $.post(
    ajax_url,
    {
      action: 'changequantity',
      nonce: nonce,
      quantity: quantity,
      itemKey: itemKey,
    },
    function () {
      loadCart();
      loadCartAmount();
    }
  );
}

function updateMeters() {
  let meters = parseFloat($(this).val());
  const minMeters = parseFloat($(this).attr('min')) || 1;
  const step = parseFloat($(this).attr('step')) || 0.25;
  const itemKey = $(this).attr('data-item');

  // Ensure meters is at least minMeters
  meters = Math.max(minMeters, meters);
  
  // Round to nearest 0.25 step
  meters = Math.round(meters / step) * step;

  $(this).val(meters);

  setCartLoader();

  $.post(
    ajax_url,
    {
      action: 'changemeters',
      nonce: nonce,
      meters: meters,
      itemKey: itemKey,
    },
    function () {
      loadCart();
      loadCartAmount();
    }
  );
}

function removeItemFromCart() {
  const itemKey = $(this).attr('data-item');

  setCartLoader();

  $.post(
    ajax_url,
    {
      action: 'deleteitem',
      nonce: nonce,
      quantity: 0,
      itemKey: itemKey,
    },
    function () {
      loadCart();
      loadCartAmount();
    }
  );
}

export function closeCart(e) {
  if (e) e.preventDefault();

  gsap.fromTo(
    '[data-cart-backdrop]',
    {
      autoAlpha: 1,
    },
    {
      autoAlpha: 0,
      duration: 0.25,
    }
  );

  gsap.fromTo(
    '[data-cart-wrap]',
    {
      translateX: '0%',
    },
    {
      translateX: '100%',
      ease: 'power1.inOut',
      duration: 0.75,
    }
  );

  document.body.classList.remove('cart-open');
}

export function openCart(e) {
  if (e) e.preventDefault();

  setCartLoader();
  loadCart();

  gsap.fromTo(
    '[data-cart-backdrop]',
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
      duration: 0.25,
    }
  );

  gsap.fromTo(
    '[data-cart-wrap]',
    {
      translateX: '100%',
    },
    {
      translateX: '0%',
      ease: 'power1.inOut',
      duration: 0.75,
    }
  );

  document.body.classList.add('cart-open');
}

export function setCartLoader() {
  gsap.fromTo(
    '[data-cart-loader]',
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
      duration: 0.25,
    }
  );
}

export function loadCart() {
  $.post(
    ajax_url,
    {
      action: 'loadcart',
      nonce: nonce,
    },
    function (response) {
      $('[data-cart-inner]').html(response.msg);

      gsap.fromTo(
        '[data-cart-loader]',
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          duration: 0.25,
        }
      );

      const shopUspsSliderCart = new Swiper('[data-shop-usps-slider-cart]', {
        loop: true,
        direction: 'vertical',
        autoplay: {
          delay: 5000,
        },
        navigation: false,
        pagination: false,
        allowTouchMove: false,
      });

      const productUpsellSlider = new Swiper('[data-product-upsell-slider]', {
        slidesPerView: 1.5,
        spaceBetween: 15,
        centeredSlides: true,
        loop: true,
        navigation: false,
        pagination: false,
        breakpoints: {
          350: {
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: false,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false,
          },
        },
      });

      customAddToCard();
      addPickupAddressClass();
    }
  );
}

export function loadCartAmount() {
  $.post(
    ajax_url,
    {
      action: 'loadcartamount',
      nonce: nonce,
    },
    function (response) {
      if (response.msg == 0) {
        $('[data-cart-amount]').html(response.msg);
        $('[data-cart-amount]').hide();
      } else {
        $('[data-cart-amount]').html(response.msg);
        $('[data-cart-amount]').show();
      }
    }
  );
}

export function customAddToCard() {
  const buttons = document.querySelectorAll('[data-add-to-card]');

  buttons.forEach(button => {
    button.addEventListener('click', handleClick);
  });

  function handleClick(event) {
    event.preventDefault();

    const pid = event.target.dataset.productId;

    if (!pid) return;

    setCartLoader();

    $.ajax({
      type: 'POST',
      url: '/wp-json/wc/store/cart/add-item',
      dataType: 'json',
      headers: {
        'Nonce': nonce,
      },
      data: {
        id: pid,
        quantity: 1,
      },
      success: function () {
        loadCart();
        loadCartAmount();
      },
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/cart.js